<template>
  <v-container class="fin-app-update"
               fill-height
               fluid>
    <v-row align="center"
           justify="center">
      <v-col style="max-width: 550px">

        <div class="text-center">
          <fin-logo-full class="mb-4"
                         dark
                         size="16em"/>

          <h2 class="font-weight-medium">
            Du verwendest eine veraltetete Version der App.
          </h2>
          <h2 class="mt-2">
            Bitte besuche
            <span v-if="platform === 'ios'">
            den Apple App Store
            </span>
            <span v-else-if="platform === 'android'">
              den Google Play Store
            </span>
            <span v-else>
              deinen Store
            </span>
            , um deine App zu aktualisieren.
          </h2>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinLogoFull from "@/components/common/logo/LogoFull"
import {Capacitor} from "@capacitor/core"

export default {
  name: "fin-app-update",
  components: {
    FinLogoFull
  },
  computed: {
    platform() {
      return Capacitor.getPlatform()
    }
  }
}
</script>

<style scoped>

</style>
